// @noflow
import { addEvent } from '~/core/state/ui/schedule/actions';
import AddEventButton from './component';
import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import { getDefaultEventValue } from '../../schedule-type';
import { getScheduleType } from '~/core/state/ui/schedule/selectors';

const mergeStateToProps = (state, { componentId }) => {
    const scheduleType = getScheduleType(state, { componentId });
    const defaultEventValue = getDefaultEventValue({ type: scheduleType });
    return { defaultEventValue };
};

const mapDispatchToProps = (dispatch, { componentId, event, maxEvents }) => {
    const dispatchAddEvent = flowRight(dispatch, addEvent);
    return {
        addEvent: (e, defaultEventValue) => {
            e.stopPropagation();
            dispatchAddEvent({
                componentId,
                defaultEventValue,
                eventToSplit: event,
                maxEvents
            });
        }
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { defaultEventValue } = stateProps;
    const { addEvent } = dispatchProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        addEvent: e => addEvent(e, defaultEventValue)
    };
};

export default connect(mergeStateToProps, mapDispatchToProps, mergeProps)(AddEventButton);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/day/add-event-button/index.js